import { APP_CONFIG } from "./constants";

const FORMSPREE_ID = process.env.REACT_APP_FORMSPREE_ID;

export const createMailToLink = (email, subject, body) => {
  const encodedSubject = encodeURIComponent(subject || '');
  const encodedBody = encodeURIComponent(body || '');
  return `mailto:${email}?subject=${encodedSubject}${encodedBody ? `&body=${encodedBody}` : ''}`;
};

export const openSupportEmail = () => {
  window.location.href = createMailToLink(
    APP_CONFIG.supportEmail,
    'Subwise Support Request'
  );
};

export const sendContactEmail = async ({ name, email, subject, message }) => {
  if (!FORMSPREE_ID) {
    throw new Error('Formspree ID is not configured');
  }

  const response = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ name, email, subject, message }),
  });

  if (!response.ok) {
    throw new Error('Failed to send message');
  }

  return response.json();
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
